// Import core lib dependencies.
import moment 			from 'moment';

// Config.
import Config			from '../config/config.js';

/**
 * <pre>
 * Goal utility methods.
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Goal.Util
 * @namespace
 */
const Goal = {

	/**
	 * Utility method to calculate if the goal has started yet.
	 *
	 */
	hasGoalStarted: function(startDate) {

		let started = false;

		// The current datetime.
		let now = moment();

		// Goal start datetime (from unix timestamp).
		let goalStart = moment(startDate);

		if(now.isAfter(goalStart)) {
			started = true;
		}

		return started;
	},

	/**
	 * Utility method to calculate if the goal has ended yet.
	 *
	 */
	hasGoalEnded: function(endDate) {

		let ended = false;

		// The current datetime.
		let now = moment();

		// Goal start datetime (from unix timestamp).
		let goalEnd = moment(endDate);

		if(now.isAfter(goalEnd)) {
			ended = true;
		}

		return ended;
	},

	/**
	 * Utility method to calculate if the goal is currently active.
	 *
	 */
	isGoalActive: function(dates) {

		let active = false;

		// If we are between the first milestone starting, and the last milestone ending.
		if(Goal.hasGoalStarted(dates.start) && !Goal.hasGoalEnded(dates.end)){
			active = true;
		}

		return active;
	},

	/**
	 * Utility method to calculate if the goal was reached
	 *
	 */
	hasGoalBeenReached: function(progress) {

		let reached = false;

		// If we have milestones.
		if(progress.percent === 100) {
			reached = true;
		}

		return reached;
	},

	/**
	 * Utility method to store the fact that a user has already participated for the given goal.
	 *
	 */
	storeUserGoalParticipation: function(metricId) {

		// Get Storage service.
		let storageService = NGXD.getServiceContainer().getService('storage');

		// Attempt to get storage object.
		let goalStorage = storageService.get(Config.storageKey);

		// Parse the JSON string into an object.
		if(goalStorage) {

			goalStorage = JSON.parse(goalStorage);

		// Otherwise, initialise storage.
		} else {

			goalStorage = {};
		}

		// Record the fact that this user has already participated for this Metric.
		goalStorage[metricId] = {
		}

		storageService.set(Config.storageKey, JSON.stringify(goalStorage));
	},

	/**
	 * Utility method to calculate if the user has already participated for the given goal.
	 *
	 */
	hasUserAlreadyParticipatedForGoal: function(metricId) {

		let alreadyParticipated = false;

		// Get Storage service.
		let storageService = NGXD.getServiceContainer().getService('storage');

		// Check for existing localstorage/cookie.
		let goalStorage = storageService.get(Config.storageKey);
		if(goalStorage) {

			// Parse the JSON string into an object.
			goalStorage = JSON.parse(goalStorage);

			// Check if an entry for this Metric Id is already set.
			if(goalStorage[metricId]) {

				alreadyParticipated = true;
			}
		}

		return alreadyParticipated;
	}

}

export default Goal;